var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('new-table',_vm._g(_vm._b({},'new-table',_vm.$props,false),_vm.$listeners),[_c('header-description',{attrs:{"totalRows":_vm.$t('total-rows'),"totalRowsCount":_vm.totalRowsCount,"fileName":_vm.fileName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }